import React, { useState } from 'react';
import './Parents_fb.css';
import { Backtotop, Underline, Alertmessage } from "../../widgets";
import { parentFeedbackQuestions } from "../../constants/feedbackQuestions";
import axios from 'axios';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const ParentsFeedback = () => {
    const [studentName, setStudentName] = useState('');
    const [registerNumber, setRegisterNumber] = useState('');
    const [branch, setBranch] = useState('');
    const [Department,setDepartment] = useState('');
    const [programme, setProgramme] = useState('');
    const [passedOutYear, setPassedOutYear] = useState('');
    const [ratings, setRatings] = useState({});
    const [errors, setErrors] = useState({});
    const [alertMessage, setAlertMessage] = useState('');

    const validateName = (name) => {
        const nameRegex = /^[A-Za-z\s]+$/;
        if (!nameRegex.test(name)) {
            setErrors(prevErrors => ({
                ...prevErrors,
                name: 'Name should only contain letters and spaces.',
            }));
            return false;
        } else {
            setErrors(prevErrors => ({ ...prevErrors, name: '' }));
            return true;
        }
    };

    const validateRatings = () => {
        const ratingErrors = {};
        parentFeedbackQuestions.forEach(({ name }) => {
            if (!ratings[name]) {
                ratingErrors[name] = 'Please select a rating (தயவுசெய்து மதிப்பீட்டை தேர்வு செய்யவும்)';
            }
        });
        setErrors(prevErrors => ({
            ...prevErrors,
            ratings: ratingErrors,
        }));
        return Object.keys(ratingErrors).length === 0;
    };

    const handleNameChange = (e) => {
        const name = e.target.value;
        setStudentName(name);
        validateName(name);
    };

    const handleRegisterNumberChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setRegisterNumber(value);
            setErrors(prevErrors => ({ ...prevErrors, registerNumber: '' })); 
        } else {
            setErrors(prevErrors => ({
                ...prevErrors,
                registerNumber: 'Register Number should only contain digits.',
            }));
        }
    };

    const handleBranchChange = (e) => setBranch(e.target.value);

    const handlePassedOutYearChange = (e) => {
        const value = e.target.value;
        setPassedOutYear(value);
        const date = new Date();
        if (value >= 1952 && value <= date.getFullYear()) {
            setErrors(prevErrors => ({ ...prevErrors, passedOutYear: '' }));
        } else {
            setErrors(prevErrors => ({
                ...prevErrors,
                passedOutYear: 'Please enter a valid year.',
            }));
        }
    };

    const handleRatingChange = (e, name) => {
        setRatings(prevRatings => ({
            ...prevRatings,
            [name]: parseInt(e.target.value, 10),
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            ratings: {
                ...prevErrors.ratings,
                [name]: '', 
            },
        }));
    };
    const handleProgrammeChange = (e) => {
        setProgramme(e.target.value);
        setErrors(prevErrors => ({ ...prevErrors, programme: '' })); 
    };

    const Parentsfeedbacksubmit = async (event) => {
        event.preventDefault();

        const isNameValid = validateName(studentName);
        const areRatingsValid = validateRatings();

        if (!isNameValid || !areRatingsValid) {
            return;
        }

        try {
            const response = await axios.post('/backend/parentsfeedbacksubmit', {
                student_name: studentName,
                register_number: registerNumber,
                branch: branch,
                programme: programme,
                passed_out_year: passedOutYear,
                ratings: ratings,
            });

            console.log(response.data);
            setAlertMessage("Feedback submitted successfully");
            setStudentName('');
            setRegisterNumber('');
            setBranch('');
            setPassedOutYear('');
            setProgramme(''); 
            setRatings({});
            setErrors({});
        } catch (error) {
            console.error('Error:', error);
            setAlertMessage("An error occurred while submitting your ratings");
        }
    };

    const handleCloseAlert = () => setAlertMessage('');
    const programmes = ["B.E","M.E","PhD"];
    const Departments = ["Civil","Mechancical","EEE","ECE","CSE"];

    return (
        <div className='parents_fb_container'>
            <Underline heading="Parent's Feedback" />
            <form className='parents_fb_form' onSubmit={Parentsfeedbacksubmit}>
                <div className='parents_fb_row'>
                    <TextField
                        className='parents_fb_1st_input'
                        label='Enter Name of student'
                        variant="outlined"
                        value={studentName}
                        onChange={handleNameChange}
                        required
                    />
                </div>
                {errors.name && <p className='parents_fb_error'>{errors.name}</p>}
                <div className='parents_fb_row'>
                    <TextField
                        className='parents_fb_1st_input' minLength={7} maxLength={11}
                        label='Enter Student Register number'
                        value={registerNumber}
                        onChange={handleRegisterNumberChange}
                        required
                    />
                </div>
                {errors.registerNumber && <p className='parents_fb_error'>{errors.registerNumber}</p>}

                <div className='parents_fb_row'>
                {/* <select
                        className="parents_fb_select"
                        value={branch}
                        onChange={handleBranchChange}
                        required
                    >
                         <option value="" disabled>Select Department*</option>
                        <option value="civil">Civil</option>
                        <option value="mech">Mech</option>
                        <option value="EEE">EEE</option>
                        <option value="ECE">ECE</option>
                        <option value="CSE">CSE</option>
                    </select> */}
                     <TextField
                        className='parents_fb_input'
                        label='Enter Passed Out Year'
                        value={passedOutYear}
                        onChange={handlePassedOutYearChange}
                        required maxLength={4}
                    />
                    <Autocomplete
                    disablePortal
                    options={Departments}
                    sx={{ width: "50%",marginBottom:"15px"  }}
                    onChange={(event, newValue) => setBranch(newValue || "")}
                    renderInput={(params) => <TextField {...params} label="Select Department" required />}                      
                    />
                   

                    </div>
                    
                
                {errors.passedOutYear && <p className='parents_fb_error'>{errors.passedOutYear}</p>}

                <div className='parents_fb_row'>
                    {/* <select
                        className="parents_fb_select"
                        value={programme}
                        onChange={handleProgrammeChange}
                        required
                    >
                        <option value="" disabled>Select Programme*</option>
                        <option value="BE">B.E</option>
                        <option value="ME">M.E</option>
                        <option value="PhD">PhD</option>
                    </select> */}
                    <Autocomplete
                    disablePortal
                    options={programmes}
                    sx={{ width: "50%",marginBottom:"15px" }}
                    onChange={(event, newValue) => setProgramme(newValue || "")}
                    renderInput={(params) => <TextField {...params} label="Select Programme" required  />}                      
                    />

                </div>

                <h2 className="parents_fb_subtitle">Please give your valuable feedback on a scale</h2>
                <div className='parents_fb_feedback'>
                    <p className='parents_fb_instruction'>5 - Excellent,   4 - Good,   3 - Satisfied,   2 - Not Satisfied,   1 - Poor</p>
                    <br />
                    {parentFeedbackQuestions.map(({ question, translation, name }) => (
                        <div className="parents_fb_question" key={name}>
                            <p>{question}</p>
                            <p>({translation})</p>
                            <div className="parents_fb_ratings">
                                {[1, 2, 3, 4, 5].map(num => (
                                    <label key={num}>
                                        <input
                                            type="radio"
                                            name={name}
                                            value={num}
                                            onChange={(e) => handleRatingChange(e, name)}
                                            checked={ratings[name] === num}
                                            required
                                        />
                                        <span className="parent_custom-radio">{num}</span>
                                    </label>
                                ))}
                            </div>
                            {errors.ratings && errors.ratings[name] && <p className='parents_fb_error'>{errors.ratings[name]}</p>}
                        </div>
                    ))}
                </div>
                <div className="parents_fb_btn">
                    <button type="submit" className="parents_fb_submit">Submit</button>
                </div>
            </form>
            <Backtotop />
            <Alertmessage message={alertMessage} onClose={handleCloseAlert} />
        </div>
    );
};

export default ParentsFeedback;
